<template>
  <div class="mainContainer">
    <div class="headContainer">
      <span class="headText">视力信息手工录入</span>
      <!--      <div class="right">-->
      <!--        <el-button-->
      <!--            class="btn"-->
      <!--            type="primary"-->
      <!--            size="medium"-->
      <!--            icon="el-icon-back"-->
      <!--            @click="$router.go(-1)">-->
      <!--          返回-->
      <!--        </el-button>-->
      <!--      </div>-->
    </div>
    <div
        class="scanContainer"
        @click="handleScan"
    >
      <div class="scanItem">---------- 扫 一 扫 ----------</div>
    </div>
    <div style="padding: 10px">
      <el-row>
        <el-col span="20">
          <el-input placeholder="请输入流水号" v-model="serialNo"></el-input>
        </el-col>
        <el-col span="4" align="center">
          <el-button style="width: 60%"
                     type="primary"
                     size="medium"
                     @click="searchBySerialNo()"
          >查询</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="baseInfo">
      <el-form
          class="ywForm"
          ref="ywForm"
          :model="ywForm"
          :rules="ywFormRules"
          label-width="80px"
      >
        <el-card class="infoCard basicInfoCard">
          <div slot="header" class="clearfix">
            <span class="boxTitle">{{ ywForm.serialNo }}号学生基础信息</span>
          </div>
          <div class="basicInfoForm">
            <el-form-item label="学校" prop="schoolName">
              <el-input v-model="ywForm.schoolName"></el-input>
            </el-form-item>
            <el-form-item label="年级:" prop="gradeCode">
              <el-select
                  v-model="ywForm.gradeCode"
                  placeholder="请选择年级"
                  filterable
              >
                <el-option-group
                    v-for="group in gradeInfos"
                    :key="group.gradeClass"
                    :label="group.gradeClass"
                >
                  <el-option
                      v-for="item in group.options"
                      :key="item.gradecode"
                      :label="item.gradename"
                      :value="item.gradecode">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="班级" prop="className">
              <el-input v-model="ywForm.className"></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="studentName">
              <el-input v-model="ywForm.studentName"></el-input>
            </el-form-item>
            <el-form-item label="性别:" prop="gender">
              <el-radio-group v-model="ywForm.gender">
                <el-radio label="1">男</el-radio>
                <el-radio label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-card>

        <el-card class="infoCard visualInfoCard">
          <div slot="header" class="clearfix">
            <span class="boxTitle">学生视力信息</span>
          </div>
          <div class="visualInfoContainer">
            <el-row :gutter="8" class="margin-bb centerContent" style="border-top: 2px solid black">
              <el-col :span="4" class="margin-bf margin-blb">戴镜<br/>情况</el-col>
              <el-col :span="20" class="margin-bfb" >
                <el-radio-group v-model="ywForm.glasscase">
                  <el-radio :label="0">未戴</el-radio>
                  <el-radio :label="1">框架镜</el-radio>
                  <el-radio :label="2">隐形镜</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row :gutter="8" class="margin-blb margin-bfb centerContent" >
              <el-col :span="24" >
                角膜塑形镜（OK镜）佩戴者
                <el-switch
                    v-model="ywForm.ceratoscope"
                    active-color="#13ce66"
                    inactive-color="#909399"
                    active-value="是"
                    inactive-value="否">
                </el-switch>
              </el-col>
            </el-row>
            <el-row :gutter="8" class="margin-bb" style="border-top: 2px solid black">
              <el-col :span="4" class="margin-bf margin-blb">眼<br/>别</el-col>
              <el-col :span="5" class="margin-bf">裸眼<br/>视力</el-col>
              <el-col :span="5" class="margin-bf">眼屈光<br/>球镜S</el-col>
              <el-col :span="5" class="margin-bf">眼屈光<br/>柱镜C</el-col>
              <el-col :span="5" class="margin-bfb">眼屈光<br/>轴位A</el-col>
            </el-row>
            <el-row :gutter="8" style="border-bottom: 1px solid blue;">
              <el-col :span="4" class="margin-bf margin-blb">右眼<br/>R</el-col>
              <el-col :span="5" class="margin-bf">
                <el-input v-model="ywForm.nakedrighteye" @blur="checkValue"></el-input>
              </el-col>
              <el-col :span="5" class="margin-bf">
                <el-input v-model="ywForm.rightobs" @blur="checkValue"></el-input>
              </el-col>
              <el-col :span="5" class="margin-bf">
                <el-input v-model="ywForm.rightopc" @blur="checkValue"></el-input>
              </el-col>
              <el-col :span="5" class="margin-bfb">
                <el-input v-model="ywForm.rightoaa" @blur="checkValue"></el-input>
              </el-col>
            </el-row>
            <el-row :gutter="8" class="margin-bb">
              <el-col :span="4" class="margin-blb  margin-bf">左眼<br/>L</el-col>
              <el-col :span="5" class="margin-bf">
                <el-input v-model="ywForm.nakedlefteye" @blur="checkValue"></el-input>
              </el-col>
              <el-col :span="5" class="margin-bf">
                <el-input v-model="ywForm.leftobs" @blur="checkValue"></el-input>
              </el-col>
              <el-col :span="5" class="margin-bf">
                <el-input v-model="ywForm.leftopc" @blur="checkValue"></el-input>
              </el-col>
              <el-col :span="5" class="margin-bfb">
                <el-input v-model="ywForm.leftoaa" @blur="checkValue"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="handleBtnContainer">
            <el-button
                type="info"
                size="medium"
                icon="el-icon-refresh-left"
                @click="resetVisualInfo"
            >
              重置
            </el-button>
            <el-button
                class="registerBtn"
                type="primary"
                size="medium"
                @click="saveVisualInfo"
                icon="el-icon-check"
                :loading="registerBtnLoading"
            >
              {{ calcBtnTitle() }}
            </el-button>
          </div>
        </el-card>

      </el-form>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk"; // 微信JS - Sdk
export default {
  name: "EmpSacnRegister",
  props: {
    serialNo: {
      type: String,
      required: false,
      default: ''
    },
    openid: {
      type: String,
      required: false,
      default: ''
    },
  },
  data() {
    return {
      ywForm: {
        id: '',
        schoolName: '',
        gradeCode: '',
        gradeName: '',
        className: '',
        studentName: '',
        gender:'',
        serialNo: '',
        nakedrighteye: null, // 右眼裸眼视力
        nakedlefteye: null, // 左眼裸眼视力
        rightobs: null, // 右球镜
        leftobs: null,
        rightopc: null, //右眼屈光柱镜C
        leftopc: null, //左眼屈光柱镜C
        rightoaa: null,
        leftoaa: null, //左眼屈光轴位A
        recordType: '',
        ceratoscope:'',
        glasscase:0
      },
      ywFormRules: {
        schoolName: [{required: true, message: "请输入学校名称", trigger: "blur"},],
        gradeCode: [{required: true, message: "请选择所属年级", trigger: "change"},],
        gender: [{required: true, message: "请选择学生性别", trigger: "change"},],
        className: [{required: true, message: "请输入班级名称", trigger: "blur"},],
        studentName: [{required: true, message: "请输入学生姓名", trigger: "blur"},],
      },
      registerBtnLoading: false,
      gradeInfos: []
    }
  },
  mounted() {
    this.initGradeInfo()
    this.getStudentInfo()
  },
  methods: {
    initGradeInfo() {
      this.getRequest("/student/getGradeInfo").then(({data}) => {
        this.gradeInfos = data
      }).catch(e => console.log("加载年级信息失败！", e.message))
    },
    calcBtnTitle() {
      let btnTitle = '录入'
      if ('2' == this.ywForm.recordType) {
        btnTitle = "修改"
      }
      return btnTitle;
    },
    handleScan() {
      console.log("扫一扫...")
      let _this = this
      this.getRequest('/api/wechatMenu/getWxConfigs?openid=' + this.openid).then((res) => {
        this.jsonData = JSON.parse(res.message);
        wx.config({
          // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          debug: false,
          // 必填，公众号的唯一标识
          appId: this.jsonData.appId,
          // 必填，生成签名的时间戳
          timestamp: "" + this.jsonData.wxConfig.timestamp,
          // 必填，生成签名的随机串
          nonceStr: this.jsonData.wxConfig.nonceStr,
          // 必填，签名
          signature: this.jsonData.wxConfig.signature,
          // 必填，需要使用的JS接口列表，所有JS接口列表
          jsApiList: ['checkJsApi', 'scanQRCode']
        });
      });
      wx.error(function (res) {
        alert("出错了：" + res.errMsg);//这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
      });

      wx.ready(function () {
        //alert("111")
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function (res) {
            var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
            // result='1234'
            // _this.openid='onpoVt1QKJbtDGTFI2JVY9E35GOs'
            // console.log(result+','+_this.openid)
            _this.serialNo = result
            _this.getStudentInfo()
          }
        });

      });
    },
    getStudentInfo() {
      console.log("加载学生档案信息：", this.serialNo)
      let queryParam = {
        serialNo: this.serialNo
      }
      this.getRequest('/employee/basic/getCheckListBySerialNo', {
        params: queryParam
      }).then((resp) => {
        if (resp && resp.status) {
          this.ywForm = resp.data
        }
      })
    },
    checkValue(event) {
      let value = event.target.value
      if (value === '' || isNaN(Number(value))) {
        // 输入为空或不是数字
        this.$message.warning('请输入有效的视力值！');
        event.target.value = null
        return false
      }
      return true
    },
    resetVisualInfo() {
      console.log("重置")
      this.ywForm.nakedrighteye = null // 右眼裸眼视力
      this.ywForm.nakedlefteye = null // 左眼裸眼视力
      this.ywForm.rightobs = null // 右球镜
      this.ywForm.leftobs = null
      this.ywForm.rightopc = null //右眼屈光柱镜C
      this.ywForm.leftopc = null //左眼屈光柱镜C
      this.ywForm.rightoaa = null
      this.ywForm.leftoaa = null //左眼屈光轴位A
    },
    saveVisualInfo() {
      this.registerBtnLoading = true
      this.$refs["ywForm"].validate(valid => {
        if (valid) {
          //校验信息
          this.ywForm.serialNo = this.serialNo
          let params = {
            ...this.ywForm,
            openid: this.openid
          }
          this.postRequest("/employee/basic/addVisualInfo", params)
              .then((resp) => {
                if (resp && resp.data) {
                  this.$message.success("录入信息成功！")
                  this.ywForm = {}
                }
              }).catch(e => console.log(e.message))
              .finally(() => {
                this.registerBtnLoading = false
              });
        } else {
          this.registerBtnLoading = false
        }
      })
    },
    searchBySerialNo(){
      this.getStudentInfo()
    }
  }
}
</script>

<style scoped>
.mainContainer {
  height: calc(100vh - 126px);
  background: rgba(246, 245, 245, 0.62);
  padding: 4px;
}

.headContainer {
  height: 40px;
  border: 1px solid #cbcbcd;
  border-radius: 4px;
  background: linear-gradient(90deg, #4278b8 30%, #4d7fb3 60%, #b1c8ee 80%);
  align-items: center; /* 垂直居中 */
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.scanContainer {
  height: 50px;
  width: 99%;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  margin: 8px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  box-shadow: 0px 2px 2px #d0d2d4;
  z-index: 1;
}

.scanItem {
  color: #babcbd;
  z-index: 2;
}

.scanContainer::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
      to bottom,
      #fff,
      #fff,
      #b2c0ce,
      #fff,
      #fff
  );
  animation: scan 3s linear infinite;
}

@keyframes scan {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(100%);
  }
}

.headContainer .right {
  display: flex; /* 使按钮水平排列 */
  justify-content: flex-end; /* 使按钮居右 */
  margin-right: 10px;
}

.headText {
  font-family: 宋体;
  font-size: 18px;
  font-weight: bold;
  line-height: 36px;
  margin-left: 10px;
  color: #fff;
}

.infoCard {
  margin-bottom: 8px;
}

.basicInfoCard {
  /*height: 285px;*/
  height: 335px;
}

.infoCard ::v-deep .el-card__header {
  padding: 8px 20px;
  background-color: #dbdde0;
}

.infoCard .boxTitle {
  color: #4d7fb3;
  font-size: 16px;
  font-weight: bold;
}

.infoCard ::v-deep .el-card__body {
  padding: 8px;
}

.visualInfoContainer {
  text-align: center;
}

.centerContent {
  display: flex;
  align-items: center;
  justify-content: center;
}

.visualInfoContainer .margin-bb {
  border-bottom: 2px solid #000000;
}

.visualInfoContainer .margin-bf {
  border-right: 1px solid #999696;
}

.visualInfoContainer ::v-deep .el-input__inner {
  margin: 0;
  padding: 0;
  border: none;
  text-align: center;
}

.visualInfoContainer .margin-blb {
  border-left: 2px solid black;
}

.visualInfoContainer .margin-bfb {
  border-right: 2px solid black;
}

.handleBtnContainer {
  text-align: center;
}

.registerBtn {
  width: 60%;
  margin-top: 10px;
}


</style>
